
import { defineComponent, ref, computed, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { usePopupStore } from '@/store/popup'
import { useDicomStore } from '@/store/dicom'
import { useExportStore } from '@/store/export';

export default defineComponent({
  components: {
  },
  props:{
  },
  setup(props, {emit}) {
    const target = ref('origin'); // origin or prediction
    const format = ref('dcm'); // dcm or png
    const dicomStore = useDicomStore();
    const dicomInfo = computed(() => dicomStore.getTargetDicomInfo);
    const singleImg = computed(() => dicomStore.getSingleImg);

    const closePopup = () => {
      usePopupStore().togglePopup('export', false);
    }

    const handleExportClick = async (): Promise<void> => {
      useExportStore().setExportOption(target.value, format.value);
      useExportStore().setExportState(true);
      closePopup();
    }

    const setTarget = (tab: string) => {
      if(!singleImg.value) {
        target.value = tab;
      }
    }

    onMounted(() => {
    });

    return {
      closePopup,
      handleExportClick,
      target,
      format,
      dicomInfo,
      setTarget,
      singleImg
    };
  },
});
